import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { EpimsBankDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-bank-view',
  templateUrl: './bank-view.component.html',
  styleUrls: ['./bank-view.component.css'],
})
export class BankViewComponent implements OnInit {
  @Input() banks: EpimsBankDto[];
  bankForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<EpimsBankDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedBank: any;
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.bankForm = this.fb.group({ Banks: this.fb.array([]) });
    this.setBank();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display banks
  setBank() {
    const control = this.bankForm.controls.Banks as FormArray;
    this.banks.forEach((e) => {
      control.push(
        this.fb.group({
          BankName: e.BankName,
          BankCode: e.BankCode,
          id: e.id,
        })
      );
    });
  }

  // method to add Bank
  addBank() {
    const control = this.bankForm.controls.Banks as FormArray;
    control.insert(
      0,
      this.fb.group({
        BankName: ['', Validators.required],
        BankCode: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete bank from arrary list
  deleteBank(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.bankForm.controls.Banks as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.banks.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.banks[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'bank';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('bank');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
